import React, { useEffect, useState } from "react";
import { Button, Col, Container, Offcanvas, Row } from "react-bootstrap";
import { Images } from "./Images";
import { NavLink } from "react-router-dom";
import Marquee from "react-fast-marquee";

const CryptoTrading = ({ cmsLits }) => {


  const [value1, setValue1] = useState()




  useEffect(() => {
    if (cmsLits) {
      setValue1(cmsLits.find((value) => (value.identifier == 'Start Trade')))
    }
  }, [cmsLits]);
  return (
    <div className="crypto_trading">
      <Container className="custom_container">
        <div className="crypto_tradingbox">
          <div className="row align-items-center">
            <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
              <div className="header_sec">
                <p className="title-txt">
                  {/* Start trading with <span className="linear-txt">crypto</span>
                <p className="mb-0">trading bot by today</p> */}
                  {value1?.heading}
                </p>
                <p className="paracontent t-grey mb-0">
                  {/* Looking ahead, Sector-8 is committed to continuous innovation
                and improvement of our trading technologies. We aim to expand
                our product offerings to include more specialized bots, catering
                to niche markets and advanced trading strategies. Our roadmap
                includes the integration of machine learning and deep learning
                techniques to enhance predictive accuracy and decision-making
                processes */}
                  {value1?.content}

                </p>
              </div>
              {/* <div className="btn_sec">
                <Button className="get_staretedBtn cmn_blueBtn">
                  Get Started
                </Button>
              </div> */}
            </div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 align-self-md-center">
              <div className="lft_imgSrc">
                <img src={Images.cryptoTrading} className="img_src img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default CryptoTrading;
